<template>
 <h1>vhosts</h1>
</template>

<script>

export default {
	name: 'vhosts'
}

</script>
